import PageLayout from './PageLayout';

const h2 = { fontSize: '1.125rem', fontWeight: 600, marginTop: '2rem', marginBottom: '0.5rem' };
const p = { color: '#94a3b8', fontSize: '0.875rem', lineHeight: 1.7, margin: '0.5rem 0' };

export default function PrivacyPage() {
  return (
    <PageLayout>
      <article style={{ maxWidth: '700px', margin: '0 auto', padding: '3rem 2rem' }}>
        <h1 style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: '0.5rem' }}>Privacy Policy</h1>
        <p style={{ ...p, color: '#64748b' }}>Last updated: May 2026</p>

        <p style={p}>
          XposureFlow is a free, non-commercial educational project. We collect as little
          data as possible and don&rsquo;t monetize any of it.
        </p>

        <h2 style={h2}>1. What We Collect</h2>
        <p style={p}>
          <strong style={{ color: '#cbd5e1' }}>Account credentials:</strong> A username and
          password are required to log in. Passwords are securely hashed &mdash; we never
          store or see them in plain text.
        </p>
        <p style={p}>
          <strong style={{ color: '#cbd5e1' }}>Server logs:</strong> Our servers may record
          IP addresses, request timestamps, and pages accessed. This is used for security
          monitoring and diagnosing technical issues.
        </p>
        <p style={p}>
          We do not collect email addresses unless you voluntarily contact us.
        </p>

        <h2 style={h2}>2. How We Use It</h2>
        <p style={p}>
          Your information is used only to authenticate your access and keep the service
          running. We don&rsquo;t sell, rent, share, or monetize your data in any way.
        </p>

        <h2 style={h2}>3. Third-Party Data Sources</h2>
        <p style={p}>
          Market data displayed on XposureFlow comes from third-party providers. We do not
          share any of your personal information with these providers. They have no knowledge
          of who uses our service.
        </p>

        <h2 style={h2}>4. Security</h2>
        <p style={p}>
          All connections to XposureFlow are encrypted. Passwords are stored using
          industry-standard one-way hashing. Your login session is stored in your
          browser and is not accessible to other sites.
        </p>

        <h2 style={h2}>5. What We Don&rsquo;t Do</h2>
        <p style={p}>
          We don&rsquo;t use third-party analytics, tracking pixels, or advertising of any kind.
          There are no cookies &mdash; just a session token stored in your browser for login.
          We don&rsquo;t build profiles, serve ads, or share data with anyone.
        </p>

        <h2 style={h2}>6. Data Retention</h2>
        <p style={p}>
          Server logs are kept for up to 30 days and then deleted. Account credentials are
          retained for as long as your account exists. If you&rsquo;d like your account
          removed, contact us at{' '}
          <a href="mailto:contact@xposureflow.io" style={{ color: '#3b82f6', textDecoration: 'none' }}>
            contact@xposureflow.io
          </a>.
        </p>

        <h2 style={h2}>7. Changes to This Policy</h2>
        <p style={p}>
          If we update this policy, the changes will be posted here with a new date.
          We won&rsquo;t make material changes without making them visible.
        </p>
      </article>
    </PageLayout>
  );
}
